const RENTERS_PENDING = 'renters_pending';
const RENTERS_FAILED = 'renters_failed';
const RENTERS_DOWNLOADED = 'renters_downloaded';
const RENTERS_RESET = 'renters_reset';
const RENTER_SENDING = 'renter_sending';
const RENTER_REMOVED = 'renter_removed';
const RENTER_DOWNLOADED = 'renter_downloaded';

export {
  RENTERS_PENDING,
  RENTERS_FAILED,
  RENTERS_DOWNLOADED,
  RENTERS_RESET,
  RENTER_SENDING,
  RENTER_REMOVED,
  RENTER_DOWNLOADED,
};



// WEBPACK FOOTER //
// ./src/store/renters/types.js